"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var context_1 = require("@apollo/client/link/context");
var models_1 = require("./models");
var axios_1 = require("axios");
var jwt_decode_1 = require("jwt-decode");
var automapper = require('automapper-ts').automapper;
var qs = require('qs');
//@ts-ignore
var apollo_upload_client_1 = require("apollo-upload-client");
var query_1 = require("./query");
var mutation_1 = require("./mutation");
var APIClient = /** @class */ (function () {
    function APIClient(apiUri, clientId, clientSecret, redirectUri) {
        this.DEBUG = false;
        this._apiUri = apiUri;
        this._clientId = clientId;
        this._clientSecret = clientSecret;
        this._redirectUri = redirectUri;
    }
    //Auth
    APIClient.prototype.isLoggedIn = function () {
        return localStorage.getItem('token') != null;
    };
    APIClient.prototype.roles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, returnValue, user, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        token = _a.sent();
                        returnValue = new Array();
                        if (token != null) {
                            try {
                                user = (0, jwt_decode_1.default)(token.id_token);
                                for (i = 0; i < user.role.length; i++) {
                                    returnValue.push(user.role[i]);
                                }
                            }
                            catch (_b) { }
                        }
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.username = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, returnValue, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        token = _a.sent();
                        returnValue = "";
                        if (token != null) {
                            try {
                                user = (0, jwt_decode_1.default)(token.id_token);
                                returnValue = user.username;
                            }
                            catch (_b) { }
                        }
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.checkAppToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenRaw, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenRaw = localStorage.getItem('app_token');
                        token = null;
                        if (tokenRaw != null && tokenRaw !== "") {
                            try {
                                token = JSON.parse(tokenRaw);
                            }
                            catch (_b) { }
                        }
                        if (!(token == null || Date.now() >= token.expires_ticks)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getNewAppToken()];
                    case 1:
                        token = _a.sent();
                        token.expires_ticks = Date.now() + token.expires_in;
                        localStorage.setItem('app_token', JSON.stringify(token));
                        _a.label = 2;
                    case 2: return [2 /*return*/, token];
                }
            });
        });
    };
    APIClient.prototype.checkToken = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenRaw, token, interactionData, newToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenRaw = localStorage.getItem('token');
                        token = null;
                        if (tokenRaw != null && tokenRaw !== "") {
                            try {
                                token = JSON.parse(tokenRaw);
                            }
                            catch (_b) { }
                        }
                        if (!("" !== code)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getNewToken(code)];
                    case 1:
                        token = _a.sent();
                        token.expires_ticks = Date.now() + (token.expires_in * 1000);
                        localStorage.setItem('token', JSON.stringify(token));
                        interactionData = new models_1.InteractionDataModel(models_1.InteractionEventType.WebSessionStart, window.location.pathname, "", new Date(), "", "", 0, new Array());
                        return [4 /*yield*/, this.createInteraction(interactionData)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(null !== token && Date.now() >= token.expires_ticks)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.refreshToken(token)];
                    case 4:
                        newToken = _a.sent();
                        token.access_token = newToken.access_token;
                        token.expires_ticks = Date.now() + (token.expires_in * 1000);
                        localStorage.setItem('token', JSON.stringify(token));
                        _a.label = 5;
                    case 5: return [2 /*return*/, token];
                }
            });
        });
    };
    APIClient.prototype.getNewToken = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, axios_1.default)({
                        method: 'post',
                        url: "".concat(this._apiUri, "/connect/token"),
                        data: qs.stringify({
                            'client_id': this._clientId,
                            'client_secret': this._clientSecret,
                            'grant_type': 'authorization_code',
                            'scope': 'openid profile offline_access roles email',
                            'code': "".concat(code),
                            'redirect_uri': this._redirectUri
                        }),
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    };
    APIClient.prototype.getNewAppToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log(this._apiUri);
                return [2 /*return*/, (0, axios_1.default)({
                        method: 'post',
                        url: "".concat(this._apiUri, "/connect/token"),
                        data: qs.stringify({
                            'client_id': this._clientId,
                            'client_secret': this._clientSecret,
                            'grant_type': 'client_credentials'
                        }),
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    };
    APIClient.prototype.refreshToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, axios_1.default)({
                        method: 'post',
                        url: "".concat(this._apiUri, "/connect/token"),
                        data: qs.stringify({
                            'client_id': this._clientId,
                            'client_secret': this._clientSecret,
                            'grant_type': 'refresh_token',
                            'scope': 'openid profile offline_access roles email',
                            'refresh_token': token.refresh_token
                        }),
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    }).then(function (response) {
                        return response.data;
                    })];
            });
        });
    };
    APIClient.prototype.runGQLQuery = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                            fetch: function () {
                                var pl = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    pl[_i] = arguments[_i];
                                }
                                if (!_this.DEBUG)
                                    return fetch.apply(void 0, pl);
                                var _ = pl[0], options = pl[1];
                                var body = JSON.parse("".concat(options === null || options === void 0 ? void 0 : options.body));
                                console.log("\uD83D\uDCE1".concat(body.operationName || '', "\n").concat(body.query), body.variables);
                                return fetch.apply(void 0, pl);
                            }
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.query(query)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    APIClient.prototype.runGQLMutation = function (mutation) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                            fetch: function () {
                                var pl = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    pl[_i] = arguments[_i];
                                }
                                if (!_this.DEBUG)
                                    return fetch.apply(void 0, pl);
                                var _ = pl[0], options = pl[1];
                                var body = JSON.parse("".concat(options === null || options === void 0 ? void 0 : options.body));
                                console.log("\uD83D\uDCE1".concat(body.operationName || '', "\n").concat(body.query), body.variables);
                                return fetch.apply(void 0, pl);
                            }
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.mutate(mutation)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    //Graphql
    APIClient.prototype.getQuizData = function (identifier) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, query, response, returnValue, trainingEpisodeContent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        query = {
                            query: (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            query {\n              trainingEpisodeContent(identifier: \"", "\", languageCode: \"en\") {\n                identifier\n                title\n                summary\n                episodeCompletedText\n                dateStart\n                dateExpires\n                isComplete\n                category\n                audiences {\n                  type\n                  value\n                }\n                contentUris {\n                  identifier\n                  type\n                  uri\n                }\n                questions {\n                  number\n                  question\n                  trainingQuestionType\n                  allowOther\n                  contentUris {\n                    identifier\n                    type\n                    uri\n                  }\n                  answers {\n                      number\n                      answer\n                      isCorrect\n                      score\n                  }\n                }\n                sections {\n                  title\n                  summary\n                  questions {\n                      number\n                      question\n                      trainingQuestionType\n                      contentUris {\n                        identifier\n                        type\n                        uri\n                      }\n                      allowOther\n                      answers {\n                          number\n                          answer\n                          isCorrect\n                          score\n                      }\n                  }\n                }\n              }\n          }"], ["\n            query {\n              trainingEpisodeContent(identifier: \"", "\", languageCode: \"en\") {\n                identifier\n                title\n                summary\n                episodeCompletedText\n                dateStart\n                dateExpires\n                isComplete\n                category\n                audiences {\n                  type\n                  value\n                }\n                contentUris {\n                  identifier\n                  type\n                  uri\n                }\n                questions {\n                  number\n                  question\n                  trainingQuestionType\n                  allowOther\n                  contentUris {\n                    identifier\n                    type\n                    uri\n                  }\n                  answers {\n                      number\n                      answer\n                      isCorrect\n                      score\n                  }\n                }\n                sections {\n                  title\n                  summary\n                  questions {\n                      number\n                      question\n                      trainingQuestionType\n                      contentUris {\n                        identifier\n                        type\n                        uri\n                      }\n                      allowOther\n                      answers {\n                          number\n                          answer\n                          isCorrect\n                          score\n                      }\n                  }\n                }\n              }\n          }"])), identifier)
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 3:
                        response = _a.sent();
                        returnValue = new models_1.TrainingEpisodeModel();
                        trainingEpisodeContent = response.data.trainingEpisodeContent;
                        returnValue.identifier = trainingEpisodeContent.identifier;
                        returnValue.title = trainingEpisodeContent.title;
                        returnValue.category = trainingEpisodeContent.category;
                        returnValue.summary = trainingEpisodeContent.summary;
                        returnValue.identifier = trainingEpisodeContent.identifier;
                        returnValue.title = trainingEpisodeContent.title;
                        returnValue.summary = trainingEpisodeContent.summary;
                        returnValue.episodeCompletedText = trainingEpisodeContent.episodeCompletedText;
                        returnValue.dateStart = trainingEpisodeContent.dateStart == null ? null : new Date(trainingEpisodeContent.dateStart);
                        returnValue.dateExpires = trainingEpisodeContent.dateExpires == null ? null : new Date(trainingEpisodeContent.dateExpires);
                        returnValue.isComplete = trainingEpisodeContent.isComplete;
                        returnValue.audiences = new Array();
                        trainingEpisodeContent.audiences.map(function (audience) {
                            returnValue.audiences.push({ type: audience.type, value: audience.value });
                        });
                        returnValue.questions = new Array();
                        returnValue.contentUris = new Array();
                        trainingEpisodeContent.contentUris.map(function (contentUri) {
                            returnValue.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, contentUri.uri, contentUri.type));
                        });
                        trainingEpisodeContent.questions.map(function (question) {
                            var answers = new Array();
                            question.answers.map(function (answer) {
                                answers.push(new models_1.AnswerModel(answer.number, answer.answer, answer.isCorrect, answer.userAnswer, answer.score));
                            });
                            if (question.allowOther)
                                answers.push(new models_1.AnswerModel(999, "Other", false, "", 0));
                            returnValue.questions.push(new models_1.QuestionModel(question.number, question.question, question.trainingQuestionType, question.contentUris, answers, question.allowOther, false, question.correctAnswerText));
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getTrainingEpisodes = function (identifier) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, response, returnValue;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            query {\n              trainingEpisodeContents(languageCode: \"en\", isActive: true) {\n                edges {\n                  node {\n                    identifier\n                    title\n                    summary\n                    episodeCompletedText\n                    dateStart\n                    dateExpires\n                    isComplete\n                    category\n                    contentType\n                    episodeNumber\n                    seasonNumber\n                    contentUris {\n                      identifier\n                      type\n                      uri\n                    }\n                    questions {\n                      number\n                      question\n                      trainingQuestionType\n                      contentUris {\n                        identifier\n                        type\n                        uri\n                      }\n                      allowOther\n                      correctAnswerText\n                      answers {\n                          number\n                          answer\n                          isCorrect\n                          score\n                      }\n                    }\n                    sections {\n                      title\n                      summary\n                      questions {\n                          number\n                          question\n                          trainingQuestionType\n                          allowOther\n                          trainingQuestionType\n                          contentUris {\n                            identifier\n                            type\n                            uri\n                          }\n                          correctAnswerText\n                          answers {\n                              number\n                              answer\n                              isCorrect\n                              score\n                          }\n                      }\n                    }\n                    entityPrerequisites {\n                      entityPrerequisiteType\n                      eventType\n                      eventIdentifier\n                      eventValue\n                      isSatisfied\n                    }\n                  }\n                }\n              }\n          }"], ["\n            query {\n              trainingEpisodeContents(languageCode: \"en\", isActive: true) {\n                edges {\n                  node {\n                    identifier\n                    title\n                    summary\n                    episodeCompletedText\n                    dateStart\n                    dateExpires\n                    isComplete\n                    category\n                    contentType\n                    episodeNumber\n                    seasonNumber\n                    contentUris {\n                      identifier\n                      type\n                      uri\n                    }\n                    questions {\n                      number\n                      question\n                      trainingQuestionType\n                      contentUris {\n                        identifier\n                        type\n                        uri\n                      }\n                      allowOther\n                      correctAnswerText\n                      answers {\n                          number\n                          answer\n                          isCorrect\n                          score\n                      }\n                    }\n                    sections {\n                      title\n                      summary\n                      questions {\n                          number\n                          question\n                          trainingQuestionType\n                          allowOther\n                          trainingQuestionType\n                          contentUris {\n                            identifier\n                            type\n                            uri\n                          }\n                          correctAnswerText\n                          answers {\n                              number\n                              answer\n                              isCorrect\n                              score\n                          }\n                      }\n                    }\n                    entityPrerequisites {\n                      entityPrerequisiteType\n                      eventType\n                      eventIdentifier\n                      eventValue\n                      isSatisfied\n                    }\n                  }\n                }\n              }\n          }"])))
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.trainingEpisodeContents.edges.map(function (trainingEpisodeEdge) {
                            var trainingEpisode = new models_1.TrainingEpisodeModel();
                            trainingEpisode.identifier = trainingEpisodeEdge.node.identifier;
                            trainingEpisode.title = trainingEpisodeEdge.node.title;
                            trainingEpisode.summary = trainingEpisodeEdge.node.summary;
                            trainingEpisode.questions = new Array();
                            trainingEpisode.episodeCompletedText = trainingEpisodeEdge.node.episodeCompletedText;
                            trainingEpisode.dateStart = trainingEpisodeEdge.node.dateStart == null ? null : new Date(trainingEpisodeEdge.node.dateStart);
                            trainingEpisode.dateExpires = trainingEpisodeEdge.node.dateExpires == null ? null : new Date(trainingEpisodeEdge.node.dateExpires);
                            trainingEpisode.isComplete = trainingEpisodeEdge.node.isComplete;
                            trainingEpisode.category = trainingEpisodeEdge.node.category;
                            trainingEpisode.contentType = trainingEpisodeEdge.node.contentType;
                            trainingEpisode.episodeNumber = trainingEpisodeEdge.node.episodeNumber;
                            trainingEpisode.seasonNumber = trainingEpisodeEdge.node.seasonNumber;
                            trainingEpisode.contentUris = new Array();
                            trainingEpisodeEdge.node.contentUris.map(function (contentUri) {
                                var pattern = /^http/i;
                                var uri = pattern.test(contentUri.uri) ? contentUri.uri : "".concat(_this._apiUri).concat(contentUri.uri, "?access_token=").concat(token.access_token);
                                trainingEpisode.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, uri, contentUri.type));
                            });
                            trainingEpisodeEdge.node.questions.map(function (question) {
                                var answers = new Array();
                                question.answers.map(function (answer) {
                                    answers.push(new models_1.AnswerModel(answer.number, answer.answer, answer.isCorrect, answer.userAnswer, answer.score));
                                });
                                if (question.allowOther)
                                    answers.push(new models_1.AnswerModel(999, "Other", false, "", 0));
                                trainingEpisode.questions.push(new models_1.QuestionModel(question.number, question.question, question.trainingQuestionType, question.contentUris, answers, question.allowOther, false, question.correctAnswerText));
                            });
                            trainingEpisode.entityPrerequisites = trainingEpisodeEdge.node.entityPrerequisites;
                            returnValue.push(trainingEpisode);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getFeedItems = function (languageCode, feedDisplayType) {
        if (languageCode === void 0) { languageCode = "en"; }
        if (feedDisplayType === void 0) { feedDisplayType = null; }
        return __awaiter(this, void 0, void 0, function () {
            var query, response, userToken, appToken, token, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.FEED_ITEMS,
                            variables: {
                                languageCode: languageCode,
                                feedDisplayType: feedDisplayType
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        returnValue = new Array();
                        response.data.feed.edges.map(function (feedEdge) {
                            var feedItem = new models_1.FeedItemModel();
                            feedItem.identifier = feedEdge.node.identifier;
                            feedItem.title = feedEdge.node.title;
                            feedItem.subTitle = feedEdge.node.subTitle;
                            feedItem.type = feedEdge.node.type;
                            feedItem.tags = feedEdge.node.tags;
                            feedItem.languageCode = feedEdge.node.languageCode;
                            feedItem.countryCode = feedEdge.node.countryCode;
                            feedItem.dateCreated = new Date(feedEdge.node.dateCreated);
                            feedItem.dateExpires = (feedEdge.node.dateExpires == null) ? null : new Date(feedEdge.node.dateExpires);
                            feedItem.dateModified = new Date(feedEdge.node.dateModified);
                            feedItem.datePublished = (feedEdge.node.datePublished == null) ? null : new Date(feedEdge.node.datePublished);
                            feedItem.linkToIdentifier = feedEdge.node.linkToIdentifier;
                            feedItem.actionUri = feedEdge.node.actionUri;
                            feedItem.isArchived = feedEdge.node.isArchived;
                            feedEdge.node.contentUris.map(function (contentUri) {
                                feedItem.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, "".concat(contentUri.uri, "?access_token=").concat(token.access_token), contentUri.type));
                            });
                            returnValue.push(feedItem);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.testEmailSend = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var mutation, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mutation = {
                            mutation: mutation_1.EMAIL_TEST_SEND,
                            variables: {
                                emailSend: data
                            }
                        };
                        return [4 /*yield*/, this.runGQLMutation(mutation)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.emailTestSend];
                }
            });
        });
    };
    APIClient.prototype.emailSend = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var mutation, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mutation = {
                            mutation: mutation_1.EMAIL_SEND,
                            variables: {
                                emailSend: data
                            }
                        };
                        return [4 /*yield*/, this.runGQLMutation(mutation)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.emailSend];
                }
            });
        });
    };
    APIClient.prototype.getSalesIncentiveOpportunities = function (campaignIdentifier, opportunityId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, userToken, appToken, token, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.SALES_INCENTIVE_OPPORTUNITIES,
                            variables: {
                                campaignIdentifier: campaignIdentifier,
                                opportunityId: opportunityId
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        returnValue = new Array();
                        response.data.salesIncentiveOpportunities.edges.map(function (edge) {
                            var item = new models_1.SalesIncentiveOpportunityModel();
                            item.campaignIdentifier = edge.node.campaignIdentifier;
                            item.customerName = edge.node.customerName;
                            item.oem = edge.node.oem;
                            item.details = edge.node.details;
                            item.dateCreated = edge.node.dateCreated;
                            item.opportunityCode = edge.node.opportunityCode;
                            item.opportunityDate = edge.node.opportunityDate;
                            item.opportunityId = edge.node.opportunityId;
                            item.status = edge.node.status;
                            item.type = edge.node.type;
                            item.user = edge.node.user;
                            item.value = edge.node.value;
                            edge.node.products.map(function (product) {
                                item.products.push(new models_1.OpportunityProductModel(product.description, product.productSku, product.quantity));
                            });
                            returnValue.push(item);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getCampaigns = function (languageCode) {
        if (languageCode === void 0) { languageCode = "en"; }
        return __awaiter(this, void 0, void 0, function () {
            var query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.CAMPAIGNS,
                            variables: {
                                languageCode: languageCode
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.campaigns.edges.map(function (edge) {
                            var item = new models_1.CampaignModel();
                            item.identifier = edge.node.identifier;
                            item.title = edge.node.title;
                            item.subTitle = edge.node.subTitle;
                            item.type = edge.node.type;
                            item.template = edge.node.template;
                            item.templateFormatType = edge.node.templateFormatType;
                            item.type = edge.node.type;
                            item.languageCode = edge.node.languageCode;
                            item.countryCode = edge.node.countryCode;
                            item.dateStart = new Date(edge.node.dateStart);
                            item.dateExpires = new Date(edge.node.dateExpires);
                            item.contentUris = new Array();
                            edge.node.contentUris.map(function (contentUri) {
                                item.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, "".concat(contentUri.uri, "?access_token_needed"), contentUri.type));
                            });
                            if (edge.node.metaData != null) {
                                edge.node.metaData.map(function (metaDataItem) {
                                    item.metaData.push(metaDataItem.key, metaDataItem.value);
                                });
                            }
                            returnValue.push(item);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getContentTemplateByIdentifier = function (identifier, campaignIdentifier) {
        if (campaignIdentifier === void 0) { campaignIdentifier = null; }
        return __awaiter(this, void 0, void 0, function () {
            var audience, userToken, appToken, token, query, response, returnValue, responseArticle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        audience = null;
                        return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        if (campaignIdentifier) {
                            audience = [{ type: models_1.AudienceType.Campaign, value: campaignIdentifier }];
                        }
                        query = {
                            query: query_1.CONTENT_TEMPLATE,
                            variables: {
                                audiences: audience,
                                languageCode: "en",
                                identifier: identifier
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 3:
                        response = _a.sent();
                        returnValue = new models_1.ContentTemplateModel();
                        responseArticle = response.data.contentTemplate;
                        returnValue.identifier = responseArticle.identifier;
                        returnValue.summary = responseArticle.summary;
                        returnValue.title = responseArticle.title;
                        returnValue.template = responseArticle.template;
                        returnValue.subTitle = responseArticle.subTitle;
                        returnValue.author = responseArticle.author;
                        returnValue.timeToRead = responseArticle.timeToRead;
                        returnValue.type = responseArticle.type;
                        returnValue.tags = responseArticle.tags;
                        returnValue.languageCode = responseArticle.languageCode;
                        returnValue.countryCode = responseArticle.countryCode;
                        returnValue.dateCreated = responseArticle.dateCreated;
                        returnValue.dateExpires = responseArticle.dateExpires;
                        returnValue.dateModified = responseArticle.dateModified;
                        returnValue.isArchived = responseArticle.isArchived;
                        returnValue.isShareable = responseArticle.isShareable;
                        responseArticle.contentUris.map(function (contentUri) {
                            returnValue.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, "".concat(contentUri.uri, "?access_token=").concat(token.access_token), contentUri.type));
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getContentTemplates = function (contentType, campaignIdentifier) {
        if (contentType === void 0) { contentType = null; }
        if (campaignIdentifier === void 0) { campaignIdentifier = null; }
        return __awaiter(this, void 0, void 0, function () {
            var audience, userToken, appToken, token, query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        audience = null;
                        return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        if (campaignIdentifier) {
                            audience = [{ type: models_1.AudienceType.Campaign, value: campaignIdentifier }];
                        }
                        query = {
                            query: query_1.CONTENT_TEMPLATES,
                            variables: {
                                languageCode: "en",
                                audiences: audience,
                                type: contentType
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 3:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.contentTemplates.edges.map(function (edge) {
                            var contentTemplate = new models_1.ContentTemplateModel();
                            var responseArticle = edge.node;
                            contentTemplate.identifier = responseArticle.identifier;
                            contentTemplate.summary = responseArticle.summary;
                            contentTemplate.title = responseArticle.title;
                            contentTemplate.template = responseArticle.template;
                            contentTemplate.subTitle = responseArticle.subTitle;
                            contentTemplate.author = responseArticle.author;
                            contentTemplate.timeToRead = responseArticle.timeToRead;
                            contentTemplate.type = responseArticle.type;
                            contentTemplate.tags = responseArticle.tags;
                            contentTemplate.languageCode = responseArticle.languageCode;
                            contentTemplate.countryCode = responseArticle.countryCode;
                            contentTemplate.dateCreated = responseArticle.dateCreated;
                            contentTemplate.dateExpires = responseArticle.dateExpires;
                            contentTemplate.dateModified = responseArticle.dateModified;
                            contentTemplate.isArchived = responseArticle.isArchived;
                            contentTemplate.isShareable = responseArticle.isShareable;
                            responseArticle.contentUris.map(function (contentUri) {
                                contentTemplate.contentUris.push(new models_1.ContentUriModel(contentUri.identifier, "".concat(contentUri.uri, "?access_token=").concat(token.access_token), contentUri.type));
                            });
                            returnValue.push(contentTemplate);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getRewards = function (languageCode, rewardType) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        query = '';
                        if (languageCode !== undefined && languageCode !== "") {
                            query = "languageCode: \"".concat(languageCode, "\"");
                        }
                        if (rewardType !== undefined) {
                            if (query !== "")
                                query += ", ";
                            query += "rewardType: ".concat(rewardType);
                        }
                        if (query !== "") {
                            query = "(".concat(query, ")");
                        }
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      query {\n        rewards", " {\n        edges {\n            node {\n            identifier\n            rewardType\n            rewardValue\n            imageUri\n            title\n            description\n            eventType\n            requiredFrequency\n            level\n            userAwarded\n            }\n        }\n        }\n    }"], ["\n      query {\n        rewards", " {\n        edges {\n            node {\n            identifier\n            rewardType\n            rewardValue\n            imageUri\n            title\n            description\n            eventType\n            requiredFrequency\n            level\n            userAwarded\n            }\n        }\n        }\n    }"])), query)
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.rewards.edges.map(function (edge) {
                            var newReward = new models_1.RewardModel();
                            newReward.identifier = edge.node.identifier;
                            newReward.rewardType = edge.node.rewardType;
                            newReward.imageUri = edge.node.imageUri;
                            newReward.title = edge.node.title;
                            newReward.description = edge.node.description;
                            newReward.eventType = edge.node.eventType;
                            newReward.requiredFrequency = edge.node.requiredFrequency;
                            newReward.level = edge.node.level;
                            newReward.userAwarded = edge.node.userAwarded;
                            newReward.rewardValue = edge.node.rewardValue;
                            returnValue.push(newReward);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getBadgeRewards = function (languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getRewards(languageCode, models_1.RewardType.Badge)];
            });
        });
    };
    APIClient.prototype.getBadgeRewardsGrouped = function (languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            var returnValue, rewards, newRewardGroup, lastRewardIdentifierGroup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnValue = new Array();
                        return [4 /*yield*/, this.getBadgeRewards(languageCode)];
                    case 1:
                        rewards = _a.sent();
                        newRewardGroup = new Array();
                        lastRewardIdentifierGroup = "";
                        rewards.map(function (reward, index) {
                            var _a, _b;
                            var rewardGroupIdentifier = (_b = (_a = reward.identifier) === null || _a === void 0 ? void 0 : _a.match(/[a-z]/i)) === null || _b === void 0 ? void 0 : _b.join();
                            if (rewardGroupIdentifier !== null && rewardGroupIdentifier !== undefined) {
                                if (lastRewardIdentifierGroup !== rewardGroupIdentifier) {
                                    if (lastRewardIdentifierGroup !== "") {
                                        returnValue.push(newRewardGroup);
                                        newRewardGroup = new Array();
                                    }
                                    lastRewardIdentifierGroup = rewardGroupIdentifier;
                                }
                                newRewardGroup.push(reward);
                                if (index === rewards.length) {
                                    returnValue.push(newRewardGroup);
                                }
                            }
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.postQuizResponse = function (data, details) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, result, episodeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, apollo_upload_client_1.createUploadLink)({
                            uri: "".concat(this._apiUri, "/graphql")
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          mutation CreateTrainingEpisodeData(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeData(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                }\n              }\n          }\n        "], ["\n          mutation CreateTrainingEpisodeData(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeData(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                }\n              }\n          }\n        "]))),
                                variables: {
                                    trainingEpisodeData: data,
                                    file: details.upload
                                }
                            })];
                    case 3:
                        result = _a.sent();
                        episodeResponse = result.data.createTrainingEpisodeData.trainingEpisode;
                        return [2 /*return*/, new models_1.TrainingEpisodeResponseDataModel(episodeResponse.episodeScore, episodeResponse.maxScore)];
                }
            });
        });
    };
    APIClient.prototype.postQuizResponseV2 = function (data, details) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, result, episodeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, apollo_upload_client_1.createUploadLink)({
                            uri: "".concat(this._apiUri, "/graphql")
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          mutation CreateTrainingEpisodeDataV2(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeDatav2(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                  rewardsAllocated {\n                    rewardId\n                    identifier\n                    rewardType\n                  }\n                }\n              }\n          }\n        "], ["\n          mutation CreateTrainingEpisodeDataV2(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeDatav2(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                  rewardsAllocated {\n                    rewardId\n                    identifier\n                    rewardType\n                  }\n                }\n              }\n          }\n        "]))),
                                variables: {
                                    trainingEpisodeData: data,
                                    file: details.upload
                                }
                            })];
                    case 3:
                        result = _a.sent();
                        episodeResponse = result.data.createTrainingEpisodeDatav2.trainingEpisode;
                        return [2 /*return*/, new models_1.TrainingEpisodeResponseDataModel(episodeResponse.episodeScore, episodeResponse.maxScore, episodeResponse.rewardsAllocated)];
                }
            });
        });
    };
    APIClient.prototype.createUpdateSalesIncentiveOpportunity = function (data, upload) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, result, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, apollo_upload_client_1.createUploadLink)({
                            uri: "".concat(this._apiUri, "/graphql")
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        result = null;
                        response = null;
                        if (!!data.opportunityId) return [3 /*break*/, 4];
                        return [4 /*yield*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            mutation CreateSalesIncentiveOpportunity(\n              $salesIncentiveOpportunityData: OpportunitySalesIncentiveInput!\n            ) {\n              createSalesIncentiveOpportunity(opportunity: $salesIncentiveOpportunityData) {\n                opportunity {\n                    opportunityId\n                    opportunityCode\n                    opportunityFiles {\n                      fileUri  \n                    }\n                  }\n                }\n            }\n          "], ["\n            mutation CreateSalesIncentiveOpportunity(\n              $salesIncentiveOpportunityData: OpportunitySalesIncentiveInput!\n            ) {\n              createSalesIncentiveOpportunity(opportunity: $salesIncentiveOpportunityData) {\n                opportunity {\n                    opportunityId\n                    opportunityCode\n                    opportunityFiles {\n                      fileUri  \n                    }\n                  }\n                }\n            }\n          "]))),
                                variables: {
                                    salesIncentiveOpportunityData: data,
                                    file: upload
                                }
                            })];
                    case 3:
                        result = _a.sent();
                        response = result.data.createSalesIncentiveOpportunity.opportunity;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, client.mutate({
                            mutation: (0, client_1.gql)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            mutation UpdateSalesIncentiveOpportunity(\n              $salesIncentiveOpportunityData: OpportunitySalesIncentiveInput!\n            ) {\n              updateSalesIncentiveOpportunity(opportunity: $salesIncentiveOpportunityData) {\n                opportunity {\n                    opportunityId\n                    opportunityCode\n                    opportunityFiles {\n                      fileUri  \n                    }\n                  }\n                }\n            }\n          "], ["\n            mutation UpdateSalesIncentiveOpportunity(\n              $salesIncentiveOpportunityData: OpportunitySalesIncentiveInput!\n            ) {\n              updateSalesIncentiveOpportunity(opportunity: $salesIncentiveOpportunityData) {\n                opportunity {\n                    opportunityId\n                    opportunityCode\n                    opportunityFiles {\n                      fileUri  \n                    }\n                  }\n                }\n            }\n          "]))),
                            variables: {
                                salesIncentiveOpportunityData: data,
                                file: upload
                            }
                        })];
                    case 5:
                        result = _a.sent();
                        response = result.data.updateSalesIncentiveOpportunity.opportunity;
                        _a.label = 6;
                    case 6:
                        returnValue = new models_1.SalesIncentiveOpportunityModel();
                        returnValue.opportunityCode = response.opportunityCode;
                        returnValue.opportunityId = response.opportunityId;
                        if (response != null && response.opportunityFiles != null) {
                            returnValue.files = new Array();
                            response.opportunityFiles.map(function (oppFile) {
                                returnValue.files.push(oppFile);
                            });
                        }
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.uploadSearchableAsset = function (data, details) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, result, episodeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, apollo_upload_client_1.createUploadLink)({
                            uri: "".concat(this._apiUri, "/graphql")
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          mutation CreateTrainingEpisodeData(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeData(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                }\n              }\n          }\n        "], ["\n          mutation CreateTrainingEpisodeData(\n            $trainingEpisodeData: TrainingEpisodeDataInput!\n          ) {\n            createTrainingEpisodeData(trainingEpisodeData: $trainingEpisodeData) {\n              trainingEpisode {\n                  episodeScore\n                  maxScore\n                }\n              }\n          }\n        "]))),
                                variables: {
                                    trainingEpisodeData: data,
                                    file: details.upload
                                }
                            })];
                    case 3:
                        result = _a.sent();
                        episodeResponse = result.data.createTrainingEpisodeData.trainingEpisode;
                        return [2 /*return*/, new models_1.TrainingEpisodeResponseDataModel(episodeResponse.episodeScore, episodeResponse.maxScore)];
                }
            });
        });
    };
    APIClient.prototype.createInteraction = function (interactionData) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, param;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        param = "";
                        if (interactionData.data !== null && interactionData.data.length > -1) {
                            param += "data: [";
                            interactionData.data.map(function (di) {
                                param += "{key: \"".concat(di.key, "\", value: \"").concat(di.value, "\"}");
                            });
                            param += "]";
                        }
                        if (interactionData.eventValue !== null) {
                            if (param !== "")
                                param += ", ";
                            param += "eventValue: \"".concat(interactionData.eventValue, "\" ");
                        }
                        if (param !== "")
                            param += ", ";
                        param += "eventType: ".concat(interactionData.eventType, " ");
                        if (interactionData.eventIdentifier !== null) {
                            if (param !== "")
                                param += ", ";
                            param += "eventIdentifier: \"".concat(interactionData.eventIdentifier, "\" ");
                        }
                        if (interactionData.campaignIdentifier !== null) {
                            if (param !== "")
                                param += ", ";
                            param += "campaignIdentifier: \"".concat(interactionData.campaignIdentifier, "\" ");
                        }
                        if (interactionData.clientIpAddress !== null) {
                            if (param !== "")
                                param += ", ";
                            param += "clientIpAddress: \"".concat(interactionData.clientIpAddress, "\" ");
                        }
                        if (interactionData.score !== null) {
                            if (param !== "")
                                param += ", ";
                            param += "score: ".concat(interactionData.score, " ");
                        }
                        if (interactionData.formSubmissionEmailToAddresses !== null && interactionData.formSubmissionEmailToAddresses.length > 0) {
                            if (param !== "")
                                param += ", ";
                            param += "formSubmissionEmailToAddresses: [\"".concat(interactionData.formSubmissionEmailToAddresses.join("\",\""), "\"] ");
                        }
                        return [2 /*return*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          mutation CreateInteraction {\n            createInteraction(interaction: {", "}) {\n              interaction {\n                campaignIdentifier\n                }\n              }\n          }\n        "], ["\n          mutation CreateInteraction {\n            createInteraction(interaction: {", "}) {\n              interaction {\n                campaignIdentifier\n                }\n              }\n          }\n        "])), param)
                            })];
                }
            });
        });
    };
    APIClient.prototype.createInteractionWebForm = function (eventIdentifier, data, formSubmissionEmailToAddresses, ipAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var interactionData;
            return __generator(this, function (_a) {
                interactionData = new models_1.InteractionDataModel(models_1.InteractionEventType.WebFormSubmit, eventIdentifier, null, new Date(), null, ipAddress, 0, new Array(), data);
                interactionData.formSubmissionEmailToAddresses = formSubmissionEmailToAddresses;
                return [2 /*return*/, this.createInteraction(interactionData)];
            });
        });
    };
    APIClient.prototype.createInteractionSimple = function (interactionEventType, eventIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var interactionData;
            return __generator(this, function (_a) {
                interactionData = new models_1.InteractionDataModel(interactionEventType, eventIdentifier, null, new Date(), null, "", 0, new Array(), new Array());
                return [2 /*return*/, this.createInteraction(interactionData)];
            });
        });
    };
    APIClient.prototype.createInteractionSimpleWithData = function (interactionEventType, eventIdentifier, data) {
        return __awaiter(this, void 0, void 0, function () {
            var interactionData;
            return __generator(this, function (_a) {
                interactionData = new models_1.InteractionDataModel(interactionEventType, eventIdentifier, null, new Date(), null, "", 0, new Array(), data);
                return [2 /*return*/, this.createInteraction(interactionData)];
            });
        });
    };
    APIClient.prototype.createCampaignInteractionSimple = function (interactionEventType, campaignIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var interactionData;
            return __generator(this, function (_a) {
                interactionData = new models_1.InteractionDataModel(interactionEventType, null, null, new Date(), campaignIdentifier, "", 0, new Array(), new Array());
                return [2 /*return*/, this.createInteraction(interactionData)];
            });
        });
    };
    APIClient.prototype.createInteractionFull = function (eventType, eventIdentifier, eventValue, campaignIdentifier, score, tags, data, ipAddress) {
        if (eventValue === void 0) { eventValue = null; }
        if (campaignIdentifier === void 0) { campaignIdentifier = null; }
        if (score === void 0) { score = 0; }
        if (tags === void 0) { tags = []; }
        if (data === void 0) { data = []; }
        return __awaiter(this, void 0, void 0, function () {
            var interactionData;
            return __generator(this, function (_a) {
                interactionData = new models_1.InteractionDataModel(eventType, eventIdentifier, eventValue, new Date(), campaignIdentifier, ipAddress, score, tags, data);
                return [2 /*return*/, this.createInteraction(interactionData)];
            });
        });
    };
    APIClient.prototype.sendEmail = function (emailData) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [2 /*return*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          mutation EmailSend(\n            $emailInputData: EmailSendInput!\n          ) {\n            emailSend(emailSend: $emailInputData) {\n              emailSend {\n                createdBy\n                }\n              }\n          }\n        "], ["\n          mutation EmailSend(\n            $emailInputData: EmailSendInput!\n          ) {\n            emailSend(emailSend: $emailInputData) {\n              emailSend {\n                createdBy\n                }\n              }\n          }\n        "]))),
                                variables: {
                                    emailInputData: emailData
                                }
                            })];
                }
            });
        });
    };
    APIClient.prototype.updateUserPreferences = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [2 /*return*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n          mutation UpdateUserPreferences(\n            $data: UserPreferenceInput!\n          ) {\n            updateUserPreferences(userPreference: $data) {\n              userPreference {\n                additionalProfileFields\n                marketingConsent\n                }\n              }\n          }\n        "], ["\n          mutation UpdateUserPreferences(\n            $data: UserPreferenceInput!\n          ) {\n            updateUserPreferences(userPreference: $data) {\n              userPreference {\n                additionalProfileFields\n                marketingConsent\n                }\n              }\n          }\n        "]))),
                                variables: {
                                    data: model
                                }
                            })];
                }
            });
        });
    };
    APIClient.prototype.updateUserAccount = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [2 /*return*/, client.mutate({
                                mutation: (0, client_1.gql)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n          mutation UpdateUserAccount(\n            $data: UserInput!\n          ) {\n            updateUserAccount(user: $data) {\n              user {\n                displayNameSafe\n              }\n            }\n          }\n        "], ["\n          mutation UpdateUserAccount(\n            $data: UserInput!\n          ) {\n            updateUserAccount(user: $data) {\n              user {\n                displayNameSafe\n              }\n            }\n          }\n        "]))),
                                variables: {
                                    data: model
                                }
                            })];
                }
            });
        });
    };
    APIClient.prototype.getAnswerData = function (identifier) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [2 /*return*/, client.query({
                                query: (0, client_1.gql)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n            query {\n              trainingEpisodeData(trainingEpisodeIdentifier: \"", "\") {\n                edges {\n                  node {\n                    user\n                    episodeScore\n                    questionData {\n                      questionNumber\n                      answerNumber\n                      attempts\n                    }\n                  }\n                }\n              }\n          }"], ["\n            query {\n              trainingEpisodeData(trainingEpisodeIdentifier: \"", "\") {\n                edges {\n                  node {\n                    user\n                    episodeScore\n                    questionData {\n                      questionNumber\n                      answerNumber\n                      attempts\n                    }\n                  }\n                }\n              }\n          }"])), identifier)
                            })];
                }
            });
        });
    };
    APIClient.prototype.isCampaignEnrolled = function (campaignIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var currentusername;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.username()];
                    case 1:
                        currentusername = _a.sent();
                        return [2 /*return*/, this.getInteractions(models_1.InteractionEventType.CampaignEnrol, campaignIdentifier, currentusername)];
                }
            });
        });
    };
    APIClient.prototype.getInteractions = function (eventType, campaignIdentifier, user, eventIdentifier) {
        if (user === void 0) { user = null; }
        if (eventIdentifier === void 0) { eventIdentifier = null; }
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        query = '';
                        if (eventType !== undefined) {
                            query = "eventType: ".concat(eventType);
                        }
                        if (campaignIdentifier !== undefined && campaignIdentifier !== "") {
                            if (query !== "") {
                                query = query + ", ";
                            }
                            query = query + "campaignIdentifier: \"".concat(campaignIdentifier, "\"");
                        }
                        if (eventIdentifier !== null && eventIdentifier !== "") {
                            if (query !== "") {
                                query = query + ", ";
                            }
                            query = query + "eventIdentifier: \"".concat(eventIdentifier, "\"");
                        }
                        if (user !== null && user !== "") {
                            if (query !== "") {
                                query = query + ", ";
                            }
                            query = query + "user: \"".concat(user, "\"");
                        }
                        if (query !== "") {
                            query = "(".concat(query, ")");
                        }
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n            query {\n              interactions", " {\n                edges {\n                  node {\n                    id\n                    user\n                    campaignIdentifier\n                    clientIpAddress\n                    crmContactId\n                    eventIdentifier\n                    eventType\n                    eventValue\n                    occurredOn\n                    score\n                  }\n                }\n              }\n          }"], ["\n            query {\n              interactions", " {\n                edges {\n                  node {\n                    id\n                    user\n                    campaignIdentifier\n                    clientIpAddress\n                    crmContactId\n                    eventIdentifier\n                    eventType\n                    eventValue\n                    occurredOn\n                    score\n                  }\n                }\n              }\n          }"])), query)
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.interactions.edges.map(function (edge) {
                            returnValue.push(new models_1.InteractionDataModel(edge.node.eventType, edge.node.eventIdentifier, edge.node.eventValue, edge.node.occurredOn, edge.node.campaignIdentifier, edge.node.clientIpAddress, edge.node.score, []));
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getLeaderboard = function (campaignIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        query = '';
                        if (campaignIdentifier !== undefined && campaignIdentifier !== "") {
                            query = "(campaignIdentifier: \"".concat(campaignIdentifier, "\")");
                        }
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n            query {\n              teamStatuses", " {\n                  edges {\n                    node {\n                      name\n                      totalPoints\n                      totalRewards\n                      teamMemberStatuses {\n                          fullName\n                          displayNameSafe\n                          totalDealRegistrationsValue\n                          totalPoints\n                          totalRewards\n                          user\n                          currentLevel\n                      }\n                    }\n                }\n              }\n          }"], ["\n            query {\n              teamStatuses", " {\n                  edges {\n                    node {\n                      name\n                      totalPoints\n                      totalRewards\n                      teamMemberStatuses {\n                          fullName\n                          displayNameSafe\n                          totalDealRegistrationsValue\n                          totalPoints\n                          totalRewards\n                          user\n                          currentLevel\n                      }\n                    }\n                }\n              }\n          }"])), query)
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new models_1.LeaderboardModel();
                        response.data.teamStatuses.edges.map(function (edge) {
                            edge.node.teamMemberStatuses.map(function (teamMember) {
                                returnValue.teamMembers.push(new models_1.TeamMemberStatusModel(teamMember.displayNameSafe, teamMember.totalDealRegistrationsValue, teamMember.totalPoints, teamMember.totalRewards, teamMember.user, teamMember.currentLevel));
                            });
                        });
                        returnValue.teamMembers = returnValue.teamMembers.sort(function (one, two) { return two.totalPoints - one.totalPoints; });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getUserStatus = function (campaignIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.USER_STATUS,
                            variables: {
                                campaignIdentifier: campaignIdentifier,
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        returnValue = new models_1.UserStatusModel(response.data.userStatus.user, response.data.userStatus.displayNameSafe, response.data.userStatus.teamName, response.data.userStatus.totalPoints, response.data.userStatus.currentLevel, response.data.userStatus.currentLevelPoints, response.data.userStatus.nextLevelIn);
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n            query {\n              user {\n                userName\n                companyLocation\n                companyName\n                countryCode\n                dateOfBirth\n                email\n                emailConfirmed\n                firstName\n                jobFunction\n                jobspecialties\n                languagePreference\n                lastName\n                phoneNumber\n                profileData\n                teamAssignments\n                displayName\n                displayNameSafe\n              }\n          }"], ["\n            query {\n              user {\n                userName\n                companyLocation\n                companyName\n                countryCode\n                dateOfBirth\n                email\n                emailConfirmed\n                firstName\n                jobFunction\n                jobspecialties\n                languagePreference\n                lastName\n                phoneNumber\n                profileData\n                teamAssignments\n                displayName\n                displayNameSafe\n              }\n          }"])))
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new models_1.UserModel();
                        returnValue.userName = response.data.user.userName;
                        returnValue.companyLocation = response.data.user.companyLocation;
                        returnValue.companyName = response.data.user.companyName;
                        returnValue.countryCode = response.data.user.countryCode;
                        returnValue.dateOfBirth = response.data.user.dateOfBirth;
                        returnValue.email = response.data.user.email;
                        returnValue.emailConfirmed = response.data.user.emailConfirmed;
                        returnValue.firstName = response.data.user.firstName;
                        returnValue.displayName = response.data.user.displayName;
                        returnValue.displayNameSafe = response.data.user.displayNameSafe;
                        returnValue.jobFunction = response.data.user.jobFunction;
                        returnValue.jobspecialties = response.data.user.jobspecialties;
                        returnValue.languagePreference = response.data.user.languagePreference;
                        returnValue.lastName = response.data.user.lastName;
                        returnValue.phoneNumber = response.data.user.phoneNumber;
                        returnValue.teamAssignments = response.data.user.teamAssignments;
                        if (response.data.user.profileData != null)
                            response.data.user.profileData.map(function (item) { var _a; return (_a = returnValue.profileData) === null || _a === void 0 ? void 0 : _a.push(new models_1.KeyValueItem(item.Key, item.Value)); });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getApplicationProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, appToken, token, httpLink, authLink, client, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkToken("")];
                    case 1:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 2:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        httpLink = (0, client_1.createHttpLink)({
                            uri: "".concat(this._apiUri, "/graphql"),
                        });
                        authLink = (0, context_1.setContext)(function (_, _a) {
                            var headers = _a.headers;
                            // get the authentication token from local storage if it exists
                            // return the headers to the context so httpLink can read them
                            return {
                                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token.access_token) : "" })
                            };
                        });
                        client = new client_1.ApolloClient({
                            link: authLink.concat(httpLink),
                            cache: new client_1.InMemoryCache()
                        });
                        return [4 /*yield*/, client.query({
                                query: (0, client_1.gql)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n            query {\n              applicationProfile {\n                additionalProfileFields {\n                  name\n                  allowOther\n                  profileFieldType\n                  values\n                }\n              }\n          }"], ["\n            query {\n              applicationProfile {\n                additionalProfileFields {\n                  name\n                  allowOther\n                  profileFieldType\n                  values\n                }\n              }\n          }"])))
                            })];
                    case 3:
                        response = _a.sent();
                        returnValue = new models_1.ApplicationProfileModel();
                        response.data.applicationProfile.additionalProfileFields.map(function (additionalProfileField) {
                            var newField = new models_1.ApplicationProfileFieldModel();
                            newField.name = additionalProfileField.name;
                            newField.allowOther = additionalProfileField.allowOther;
                            newField.profileFieldType = additionalProfileField.profileFieldType;
                            newField.values = additionalProfileField.values;
                            returnValue.additionalProfileFields.push(newField);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getAssets = function (campaignIdentifier, searchQuery) {
        if (campaignIdentifier === void 0) { campaignIdentifier = null; }
        if (searchQuery === void 0) { searchQuery = null; }
        return __awaiter(this, void 0, void 0, function () {
            var audience, query, response, userToken, appToken, token, assets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        audience = null;
                        if (campaignIdentifier) {
                            audience = [{ type: models_1.AudienceType.Campaign, value: campaignIdentifier }];
                        }
                        query = {
                            query: query_1.ASSETS,
                            variables: {
                                audiences: audience,
                                query: searchQuery,
                                after: null,
                                first: 10000
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        assets = new Array();
                        response.data.assets.edges.map(function (assetEdge) {
                            assets.push(new models_1.AssetModel(assetEdge.node.name, assetEdge.node.type, assetEdge.node.fullUri, "".concat(assetEdge.node.uri, "?access_token=").concat(token.access_token), assetEdge.node.description, assetEdge.node.thumbnail, assetEdge.node.tags, assetEdge.node.productFamily, assetEdge.node.productModel));
                        });
                        return [2 /*return*/, assets];
                }
            });
        });
    };
    APIClient.prototype.getEmailTemplates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, userToken, appToken, token, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.EMAIL_TEMPLATES,
                            variables: {
                                after: null,
                                first: 10000
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        returnValue = new Array();
                        response.data.emailTemplates.edges.map(function (emailTemplateEdge) {
                            var emailTemplate = new models_1.SendGridEmailTemplate();
                            emailTemplate.templateId = emailTemplateEdge.node.templateId;
                            emailTemplateEdge.node.version.map(function (ver) {
                                var newVersion = new models_1.SendGridEmailTemplateVersion();
                                newVersion.id = ver.id;
                                newVersion.name = ver.name;
                                newVersion.htmlContent = ver.htmlContent;
                                newVersion.thumbnailUrl = ver.thumbnailUrl;
                                emailTemplate.version.push(newVersion);
                            });
                            returnValue.push(emailTemplate);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getExistingEmailSends = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, returnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.EXISTING_EMAIL_SEND,
                            variables: {
                                after: null,
                                first: 10000
                            }
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        returnValue = new Array();
                        response.data.existingEmailSends.edges.map(function (edge) {
                            returnValue.push(edge.node);
                        });
                        return [2 /*return*/, returnValue];
                }
            });
        });
    };
    APIClient.prototype.getMyTeams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, userToken, appToken, token, assets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.MY_TEAMS
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        assets = new Array();
                        response.data.myTeams.edges.map(function (assetEdge) {
                            var profileData = new Array();
                            assetEdge.node.profileData.map(function (pdi) { profileData.push(new models_1.KeyValueItem(pdi.Key, pdi.Value)); });
                            assets.push(new models_1.TeamModel(assetEdge.node.identifier, assetEdge.node.emailSuffixList, assetEdge.node.division, assetEdge.node.locations, assetEdge.node.longName, assetEdge.node.name, profileData));
                        });
                        return [2 /*return*/, assets];
                }
            });
        });
    };
    APIClient.prototype.getTeams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, response, userToken, appToken, token, assets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            query: query_1.TEAMS
                        };
                        return [4 /*yield*/, this.runGQLQuery(query)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.checkToken("")];
                    case 2:
                        userToken = _a.sent();
                        return [4 /*yield*/, this.checkAppToken()];
                    case 3:
                        appToken = _a.sent();
                        token = userToken ? userToken : appToken;
                        assets = new Array();
                        response.data.teams.edges.map(function (assetEdge) {
                            assets.push(new models_1.TeamModel(assetEdge.node.identifier, assetEdge.node.emailSuffixList, assetEdge.node.division, assetEdge.node.locations, assetEdge.node.longName, assetEdge.node.name, assetEdge.node.profileData));
                        });
                        return [2 /*return*/, assets];
                }
            });
        });
    };
    return APIClient;
}());
exports.default = APIClient;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;
